import {Mutation} from './mutation-types'

export default {
    createAccordionCollapseState({commit}, payload) {
        commit(Mutation.CREATE_COLLAPSE_STATE, payload)
    },
    updateAccordionCollapseState({commit}, payload) {
        commit(Mutation.UPDATE_COLLAPSE_STATE, payload)
    },
    deleteAccordionCollapseState({commit}, payload) {
        commit(Mutation.DELETE_COLLAPSE_STATE, payload)
    },
    closeAccordionCollapseStates({commit}, payload) {
        commit(Mutation.CLOSE_COLLAPSE_STATES, payload)
    },


    createRow({commit}, payload){
        commit(Mutation.CREATE_ROW, payload)
    },
    updateRow({commit}, payload) {
        commit(Mutation.UPDATE_ROW, payload)
    },
    deleteRow({commit}, payload) {
        commit(Mutation.DELETE_ROW, payload)
    },
    deleteAllRows({commit}, payload) {
        commit(Mutation.DELETE_ALL_ROWS, payload)
    }

}
